/** @file Password-reset view. */
import { resetPassword, mapAuthError } from "../../persistence/auth.js";
import { h, clear } from "../dom.js";

/**
 * @param {HTMLElement} host
 */
export function mountResetView(host) {
  clear(host);
  const emailInput = h("input", {
    type: "email",
    name: "email",
    autocomplete: "email",
    required: true,
    class: "hb-auth-input",
  });
  const statusEl = h("div", { class: "text-sm text-green-400 min-h-5", role: "status" });
  const errorEl = h("div", { class: "text-sm text-red-400 min-h-5", role: "alert" });
  const submit = h("button", { type: "submit", class: "hb-btn hb-btn--primary min-h-11 mt-2" }, [
    "Link senden",
  ]);
  const form = h("form", { class: "flex flex-col gap-3" }, [
    h("label", { class: "flex flex-col gap-1 text-sm" }, [h("span", null, ["E-Mail"]), emailInput]),
    submit,
    statusEl,
    errorEl,
  ]);
  const card = h(
    "div",
    {
      class:
        "hb-auth-card max-w-sm mx-auto mt-16 p-6 rounded-2xl bg-neutral-800 shadow-xl text-neutral-100",
    },
    [
      h("h1", { class: "text-2xl font-bold mb-4" }, ["Passwort zurücksetzen"]),
      form,
      h("div", { class: "mt-4 text-sm" }, [
        h("a", { href: "#/login", class: "text-blue-400 hover:text-blue-300" }, [
          "Zurück zur Anmeldung",
        ]),
      ]),
    ],
  );
  host.appendChild(card);

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    statusEl.textContent = "";
    errorEl.textContent = "";
    try {
      await resetPassword(/** @type {HTMLInputElement} */ (emailInput).value);
    } catch (err) {
      console.warn("[auth] resetPassword error", mapAuthError(err));
    }
    statusEl.textContent = "Falls ein Konto existiert, wurde eine E-Mail versendet.";
  });
}
